import { customAsync, nullishAsync, pipeAsync } from "valibot";
import { dataSource, errorTranslation, requireResource, resource } from "./base";
import { runWithOwner } from "solid-js";
import ApiService from "../../services/ApiService";
import { isNil } from "lodash-es";
import owner from "../../owner";
import CustomerResourceService from "../../services/CustomerResourceService";
import type FormId from "../../state/FormId";
import { keyFromSelector } from "i18next";

export const dataSourceAsync = (formId: FormId) =>
  pipeAsync(
    dataSource(),
    customAsync(
      async (properties) => {
        const { id } = properties as { id: string };
        const remoteDataSource = await runWithOwner(owner(), () => ApiService.getDataSourceInfo(id, formId));
        return !isNil(remoteDataSource);
      },
      errorTranslation(keyFromSelector(($) => $.VALIDATION_DATA_SOURCE_DELETED)),
    ),
  );

export const requireResourceAsync = () =>
  pipeAsync(
    requireResource(),
    customAsync<string>(
      async (id) => {
        const exists = await runWithOwner(owner(), () => CustomerResourceService.exists(id as string));
        return isNil(exists) ? false : exists;
      },
      errorTranslation(keyFromSelector(($) => $.VALIDATION_IMAGE_DELETED)),
    ),
  );
export const resourceAsync = () =>
  nullishAsync(
    pipeAsync(
      resource(),
      customAsync<string | null | undefined>(
        async (id) => {
          if (isNil(id)) {
            return true;
          }

          const exists = await runWithOwner(owner(), () => CustomerResourceService.exists(id as string));
          return isNil(exists) ? false : exists;
        },
        errorTranslation(keyFromSelector(($) => $.VALIDATION_IMAGE_DELETED)),
      ),
    ),
  );
